<template>
    <div class="aui-flexView" style="z-index: 6">
      <!-- <top :title="getTopTitle()"></top> -->
      <transition :name="transitionName">
        <router-view ></router-view>
      </transition>
    </div>
</template>

<script>
// import Top from '@/components/layer2/books/books-top'
export default {
  name: 'books-index',
  data () {
    return {
      transitionName: 'right'
    }
  },
  computed: {

  },
  methods: {
    getTopTitle () {
      return this.$route.meta.topTitle
    }
  },
  components: {
    // top: Top
  }
}
</script>

<style scoped>

</style>
